import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateSuccess',
  emits: ['step-set'],
  setup(__props, { emit: __emit }) {

const emits = __emit

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_result = _resolveComponent("el-result")!

  return (_openBlock(), _createBlock(_component_el_result, {
    icon: "success",
    title: "提交成功",
    "sub-title": "生成任务创建成功，请查看下方列表状态"
  }, {
    extra: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('step-set', 0)))
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode("再来一份")
        ])),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})